import { Button } from '@cimpress/react-components';
// tslint:disable-next-line:import-name
import DatePicker from '@cimpress/react-components/lib/DatePicker';
import momentTimezone, { Moment } from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { LocaleSettings } from '../../../models/location';

// tslint:disable-next-line:import-name
import style from '../index.module.css';

export interface DateFilterProps {
  className?: string;
  title: string;
  localeSettings: LocaleSettings;
  isValidDate: (current: Moment) => boolean;
  onChange: (value?: Moment) => void;
}

// tslint:disable-next-line:function-name
export default function DateFilter(
  {
    className,
    isValidDate,
    localeSettings,
    onChange,
    title,
  }: DateFilterProps,
) {
  const [date, setDate] = useState<Moment>();
  useEffect(
    () => {
      onChange(date);
    },
    [date],
  );

  return <div className={`${className ?? ''} ${style.Date}`}>
    <h6>{title}</h6>
    <DatePicker
      placeholder="Select a date"
      dateFormat={localeSettings.dateFormat}
      displayTimeZone={localeSettings.timezone}
      onChange={value => setDate(momentTimezone(value))}
      value={date}
      isValidDate={isValidDate}
      renderInput={props => <input {...props} value={date ? props.value : ''} />}
    />
    {date && <Button
      type="link"
      className={`${style.Clear}`}
      onClick={() => setDate(undefined)}
    >
      <i className="fa fa-times"></i>
    </Button>}
  </div>;
}
